export enum PixMenu {
	MEUQRCODE,
	PAGAMENTO,
	RECEBER,
	CHAVES,
	EXTRATO,
	DUVIDAS,
	LIMITES,
	COPIACOLA,
	SAQUETROCO,
	DEBITOAUTOMATICOPIX,
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/pix-menu.enum.ts